import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import Sidebar from "../Common/Sidebar";
import CommonValues from "../Common/utils";
import notebooklm from "../assets/images/notebooklogo.svg";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import Loader from "../Common/Loader";

type NotebookItem = {
  id: number;
  userId: number;
  title: string;
  launch_Url: string;
  chat_Url: string;
};

export default function NotebookLMLandingPage() {
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const [pagename, setPageName] = useState("notebooklm");
  const [notebooks, setNotebooks] = useState<NotebookItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [showdeleteDialog, setshowDeleteDialog] = useState(false);
  const [notebookIdToDelete, setNotebookIdToDelete] = useState<number | null>(
    null
  );
  const [notebookTitleToDelete, setNotebookTitleToDelete] = useState("");
  const [saving, setSaving] = useState(false);
  const [newNotebook, setNewNotebook] = useState({
    title: "",
    launch_Url: "",
    chat_Url: "",
  });
  const [errors, setErrors] = useState({
    title: false,
    launch_Url: false,
    chat_Url: false,
  });
  const [submitted, setSubmitted] = useState(false);

  const fetchNotebooks = async () => {
    setLoading(true);
    try {
      const token = CommonValues.GetToken();
      const response = await axios.get(
        `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/getall/notebooklm`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNotebooks(response.data.data || []);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchNotebooks();
  }, []);

  const handleSave = async () => {
    setSubmitted(true);

    const newErrors = {
      title: newNotebook.title.trim() === "",
      launch_Url: newNotebook.launch_Url.trim() === "",
      chat_Url: newNotebook.chat_Url.trim() === "",
    };

    setErrors(newErrors);

    if (Object.values(newErrors).some(Boolean)) return;

    try {
      setSaving(true);
      const token = CommonValues.GetToken();
      await axios.post(
        `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/notebooklm/insert`,
        {
          title: newNotebook.title,
          launch_Url: newNotebook.launch_Url,
          chat_Url: newNotebook.chat_Url,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      await fetchNotebooks();
      setNewNotebook({ title: "", launch_Url: "", chat_Url: "" });
      setShowAddDialog(false);
      setSubmitted(false);
    } catch (err) {
      console.error("Save failed", err);
    } finally {
      setSaving(false);
    }
  };

  const openDeleteDialog = (id: number, title: string) => {
    setNotebookIdToDelete(id);
    setNotebookTitleToDelete(title);
    setshowDeleteDialog(true);
  };

  const cancelDelete = () => {
    setshowDeleteDialog(false);
    setNotebookIdToDelete(null);
    setNotebookTitleToDelete("");
  };

  const confirmDelete = async () => {
    if (notebookIdToDelete === null) return;
    try {
      const token = CommonValues.GetToken();
      await axios.delete(
        `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/Removenotebook/${notebookIdToDelete}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setshowDeleteDialog(false);
      setNotebookIdToDelete(null);
      setNotebookTitleToDelete("");
      await fetchNotebooks();
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  const filteredNotebooks = useMemo(
    () =>
      notebooks.filter((n) =>
        n.title.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    [searchTerm, notebooks]
  );
  const clearAddNotebookForm = () => {
    setNewNotebook({
      title: "",
      launch_Url: "",
      chat_Url: "",
    });
    setSubmitted(false);
    setErrors({
      title: false,
      launch_Url: false,
      chat_Url: false,
    });
  };

  const onSidebarValueChanged = (value: any) => setShowWideSidebar(value);

  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar
        pagename={pagename}
        setPageName={setPageName}
        onSidebarValueChanged={onSidebarValueChanged}
      />
      <div
        className={`flex-grow-1 d-flex flex-column bg-light p-2 mt-4 ${
          showWideSidebar
            ? "main-content-large-width"
            : "main-content-small-width"
        }`}
      >
        <div>
          <h2 className="fw-bold mb-1">Notebook LM</h2>
          <p className="text-muted">
            {" "}
            Explore your saved Google NotebookLM links.
          </p>
        </div>
        <Card className=" p-0 bordered-container shadow-sm px-3">
          {loading ? (
            <div className="d-flex justify-content-center">
              {" "}
              <Loader />{" "}
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-start px-1">
                <input
                  type="text"
                  placeholder="Search by title..."
                  className="notebook-search-icon"
                  style={{
                    border: "1px solid #770ebdbc",
                    borderRadius: "10px",
                    width: "50%",
                  }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Button
                  className="notebookadd-btn alexandria-btn d-flex align-items-center gap-2"
                  onClick={() => setShowAddDialog(true)}
                >
                  <img
                    src={notebooklm}
                    alt="Notebook LM"
                    style={{ width: 16, height: 20 }}
                  />
                  Add New
                </Button>
              </div>
              <div className="notebooklm-grid mt-4">
                {filteredNotebooks.map((item) => (
                  <div key={item.id} className="notebooklmcard">
                    <Button
                      icon="pi pi-trash"
                      className="p-button-text p-button-sm delete-icon"
                      onClick={() => openDeleteDialog(item.id, item.title)}
                    />
                    <img
                      src={notebooklm}
                      alt="Notebook LM"
                      className="notebooklm-icon"
                    />
                    <div className="notebooklm-title">{item.title}</div>
                    <div className="notebooklm-buttons">
                      <Button
                        label="Launch"
                        icon="pi pi-external-link"
                        className="primary-btn alexandria-btn"
                        onClick={() => window.open(item.launch_Url, "_blank")}
                      />
                      <Button
                        label="Open Chat"
                        icon="pi pi-comments"
                        className="secondary-btn alexandria-btn"
                        onClick={() => window.open(item.chat_Url, "_blank")}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </Card>
        <Dialog
          header="Add New Notebook"
          visible={showAddDialog}
          onHide={() => setShowAddDialog(false)}
          style={{ width: "500px" }}
          className="text-14 styled-dialog"
          modal
        >
          <div className="d-flex flex-column gap-4 mt-4">
            <div>
              <div className="d-flex align-items-center gap-3">
                <label className="m-0 text-purple" style={{ width: "150px" }}>
                  Title<span className="text-danger"> * </span>
                </label>
                <div className="flex-grow-1">
                  <InputText
                    value={newNotebook.title}
                    onChange={(e) =>
                      setNewNotebook({ ...newNotebook, title: e.target.value })
                    }
                    placeholder="Enter Title"
                    className={`w-100 text-12 ${
                      submitted && errors.title ? "input-error" : ""
                    }`}
                  />
                  {submitted && errors.title && (
                    <small className="text-danger">Title is required</small>
                  )}
                </div>
              </div>
            </div>

            <div>
              <div className="d-flex align-items-center gap-3">
                <label className="m-0 text-purple" style={{ width: "150px" }}>
                  Launch Url<span className="text-danger"> * </span>
                </label>
                <div className="flex-grow-1">
                  <InputText
                    value={newNotebook.launch_Url}
                    onChange={(e) =>
                      setNewNotebook({
                        ...newNotebook,
                        launch_Url: e.target.value,
                      })
                    }
                    placeholder="Enter Launch URL"
                    className={`w-100 text-12 ${
                      submitted && errors.launch_Url ? "input-error" : ""
                    }`}
                  />
                  {submitted && errors.launch_Url && (
                    <small className="text-danger">
                      Launch URL is required
                    </small>
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className="d-flex align-items-center gap-3">
                <label className="m-0 text-purple" style={{ width: "150px" }}>
                  Chat Url<span className="text-danger"> * </span>
                </label>
                <div className="flex-grow-1">
                  <InputText
                    value={newNotebook.chat_Url}
                    onChange={(e) =>
                      setNewNotebook({
                        ...newNotebook,
                        chat_Url: e.target.value,
                      })
                    }
                    placeholder="Enter Chat URL"
                    className={`w-100 text-12 ${
                      submitted && errors.chat_Url ? "input-error" : ""
                    }`}
                  />
                  {submitted && errors.chat_Url && (
                    <small className="text-danger">Chat URL is required</small>
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-2">
              <Button
                label="Cancel"
                className="alexandria-btn secondary-btn"
                onClick={() => {
                  setShowAddDialog(false);
                  clearAddNotebookForm();
                }}
              />
              <Button
                className="alexandria-btn primary-btn d-flex align-items-center justify-content-center gap-2"
                onClick={handleSave}
                disabled={saving}
              >
                Save
                {saving && (
                  <i
                    className="pi pi-spin pi-spinner"
                    style={{ fontSize: "1rem" }}
                  />
                )}
              </Button>
            </div>
          </div>
        </Dialog>
        <Dialog
          header="Confirm Delete"
          visible={showdeleteDialog}
          style={{ width: "375px" }}
          modal
          onHide={cancelDelete}
          className="styled-dialog"
          footer={
            <div className="d-flex justify-content-center mb-0 mt-0">
              <Button
                label="Cancel"
                icon="pi pi-times"
                onClick={cancelDelete}
                className="alexandria-btn secondary-btn me-4"
              />
              <Button
                label="Delete"
                icon="pi pi-trash"
                onClick={confirmDelete}
                className="p-button curved-button primary-btn"
              />
            </div>
          }
        >
          <p className="mt-2">
            Are you sure you want to delete Notebook{" "}
            <strong>{notebookTitleToDelete}</strong>?
          </p>
        </Dialog>
      </div>
    </div>
  );
}